// extracted by mini-css-extract-plugin
module.exports = {"page":"_2ksElZ7lYCl32urMh8E_NB"};